import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import { useMediaQuery } from "material-ui-core";
import CircularProgressBar from "./CircularProgressBar";
import "./Badge.scss";
import { percentageCalculation } from "../../common/utilities";
import { generateSensitiveData } from "../../views/manageDataMap/locationCommonComponents";
import { formatToMillion } from "../../common/commonUtilities";

export default function SensitivityBadge({ parentprops, loc, title }) {
  const isSmall = useMediaQuery("(max-width:1600px)");
  if (!parentprops) return null;

  const { total_sensitivity_count = 0 } = parentprops;

  const sensitiveData = generateSensitiveData(loc, parentprops);

  const isVeryCompact = loc === "DataTagDrives";

  const isCompact =
    loc === "InspectContent" ||
    loc === "DataOwner" ||
    loc === "DataOwnerTable" ||
    isSmall;

  const width = isCompact ? (isVeryCompact ? 30 : 40) : 85;
  const height = isCompact ? (isVeryCompact ? 33 : 40) : 45;

  const containerClass = (() => {
    switch (loc) {
      case "InspectContent":
        return "chip-container sensitivity inspect-content inspect-sensitivity";
      case "DataOwner":
        return "chip-container sensitivity inspect-content inspect-sensitivity dataOwner";
      case "DataOwnerTable":
        return "chip-container sensitivity inspect-content inspect-sensitivity dataOwnerTable";
      default:
        return "chip-container sensitivity";
    }
  })();

  const sensitiveBadgeData = (() => {
    if (total_sensitivity_count === 0) {
      return sensitiveData.map((e) => ({
        name: e.name,
        color: e.color,
        percentage: 0,
        count: e.count,
        value: e.value,
        titlePercentage: "0.00",
      }));
    }

    const floorValues = percentageCalculation(
      sensitiveData,
      total_sensitivity_count
    );

    return sensitiveData.map((item) => {
      const floorValue = floorValues.find((val) => val.color === item.color);

      return {
        name: item.text,
        color: item.color,
        percentage: floorValue?.count || 0,
        count: item.count || 0,
         value: item.value,
        titlePercentage: floorValue?.unRoundPercentage || "0.00",
      };
    });
  })();

  const renderNoOfFiles = (row) => {
    if (loc !== "DataOwner" && loc !== "DataOwnerTable") return null;

    return (
      <div
        className={
          loc === "DataOwner"
            ? `dataOwnerColor ${row.color}`
            : `dataOwnerColor ${row.color} table`
        }
        title={row.count}
      >
        {formatToMillion(row.count)}
      </div>
    );
  };

  const renderTitle =
    loc === "DataOwner" ? (
      <div className="dataOwnerSensitiveHeading">
        <div className="dataOwnerTitles">
          <span>{title}</span>
        </div>
        <div className="dataOwnerTitles">
          <span>Sensitivity in no.</span>
        </div>
      </div>
    ) : (
      <div className="dataOwnerTitles">{title}</div>
    );

  const renderMainComponent = () => {
    if (loc === "DataTagDrives") {
      return (
        <Paper
          component="ul"
          className="chip-container dataTagDrivesSensitivity"
        >
          {sensitiveBadgeData.map((row) => (
            <div key={row.color} className="dataOwnerSensitive">
              <Box
                className="box-wrapper"
                sx={{ position: "relative", display: "inline-flex" }}
              >
                <CircularProgressBar
                  strokeWidth={13}
                  titlePercentage={row.titlePercentage}
                  percentage={row.percentage}
                  count={row.count}
                  value={row.value}
                  severity={row.color}
                  width={width}
                  height={height}
                  title={row.name}
                  loc={loc}
                />
              </Box>
              {renderNoOfFiles(row)}
            </div>
          ))}
        </Paper>
      );
    } else {
      return (
        <Paper component="ul" className={containerClass}>
          {renderTitle}
          {sensitiveBadgeData.map((row) => (
            <div key={row.color} className="dataOwnerSensitive">
              <Box
                className="box-wrapper"
                sx={{ position: "relative", display: "inline-flex" }}
              >
                <CircularProgressBar
                  strokeWidth={13}
                  titlePercentage={row.titlePercentage}
                  percentage={row.percentage}
                  count={row.count}
                  value={row.value}
                  severity={row.color}
                  width={width}
                  height={height}
                  title={row.name}
                  loc={loc}
                />
              </Box>
              {renderNoOfFiles(row)}
            </div>
          ))}
        </Paper>
      );
    }
  };

  return loc === "DataTag" ? (
    <Paper component="ul" className={containerClass}>
      {sensitiveBadgeData.map((row) => (
        <div key={row.color} className="dataTagSensitiveContainer">
          <div
            className={`sensitiveChip ${
              row.name !== "Non Classified" ? row.name : "NonClassified"
            }`}
            title={`${row.name}: ${row.count}`}
          >
            {row.name}
          </div>

          <div className="dataOwnerSensitive">
            <Box
              className="box-wrapper"
              sx={{ position: "relative", display: "inline-flex" }}
            >
              <CircularProgressBar
                strokeWidth={13}
                titlePercentage={row.titlePercentage}
                percentage={row.percentage}
                count={row.count}
                severity={row.color}
                width={width}
                height={height}
                title={row.name}
                loc={loc}
              />
            </Box>
          </div>

          {renderNoOfFiles(row)}
        </div>
      ))}
    </Paper>
  ) : (
    renderMainComponent()
  );
}
